import React from "react";
import { Stack, Typography } from "@mui/material";
import { HubHookFormInput, HubHookFormSelect } from "../../components";
import {
  BarcodeDimensions,
  BarcodeFormats,
  Data_Object_Keys,
  Data_Objects,
  getDataObjectKey,
} from "../../constants/barcodes";
import { useFormContext } from "react-hook-form";

const BarcodeSettings = ({ disabled = false, disableType = false }) => {
  const { watch } = useFormContext();
  const source = watch("source");
  const dataSource = getDataObjectKey(source);
  const hideQty = !!dataSource.key;

  return (
    <Stack width="100%" gap="15px">
      <Typography variant="boldCaptionMain">Barcode Settings</Typography>
      <Stack width="100%" gap="10px">
        <Stack direction="row" gap="5px">
          <HubHookFormSelect
            name="size"
            label="Size"
            options={BarcodeDimensions}
            disabled={disabled}
            required
          />
          <HubHookFormSelect
            name="format"
            label="Format"
            options={BarcodeFormats}
            disabled={disabled}
            required
          />
        </Stack>
        <Stack direction="row" gap="5px">
          <HubHookFormSelect
            name="object"
            label="Parent Object"
            options={Data_Objects}
            disabled={disabled || disableType}
            required
          />
          <HubHookFormSelect
            name="source"
            label="Source"
            options={Data_Object_Keys}
            disabled={disabled}
            required
          />
          <HubHookFormInput
            name="quantity"
            label="Quantity"
            hidden={hideQty}
            isNumber
          />
        </Stack>
      </Stack>
    </Stack>
  );
};

export default BarcodeSettings;
